// import waypoints from node_modules
//import 'waypoints/lib/jquery.waypoints';
//import 'waypoints/lib/shortcuts/sticky';


jQuery(function($) {

});
  